import { getMapCenterData, getMyProfileData, getSupportData, getAIUserProfileData, IndividualUserData, announcementData, faqData, marketerGetData, marketerGroupGetData } from '_utils/constant';
import { portalAccessData } from '_utils/constant';
import { portalData, userRegistrationVerified } from '_utils/constant';
import { getSupplierDiversityData } from '_utils/constant';
import {
  currentBilling,
  profileInfo,
  energyUsage,
  reconnectServiceResponse,
  accountLookupResponse,
  grantInfo,
  accountBalanceResponse,
  billingAndPaymentHistory,
  billHistoryPDF,
  currentBillingPDF,
  emergencyHold,
  emergencyHoldStatus,
  energyUsageReport,
  energyUsageResponse,
  advanceSearchResponse,
  pledgeAmtSuccess,
  pledgeAmtFailed,
  agencyList,
  outstandingGrantData,
  getAvailableAppointmentResponse,
} from "../services/energyAssistance/mockData";
import {
  businessCategory,
  classification,
  documentType,
  postRegisteredSupplierDownloadReport,
  state
} from "../services/supplierDiversity/mockData"
import { getPartiallyApprovedDetailsResponse, getCountyResponse, getFilteredMapRequestResponse, getRequestTypeResponse, getStateResponse, getViewHistoryResponse, postMapRequestCreateResponse,postMapRequestCreateFailedResponse, getMapRequestByIdFailedReponse, getMapRequestByIdRequest, getMapRequest, getMCReqTypeResponse, postPartiallyApproveUserResponse, updatePartiallyApprovedResponse, } from 'services/mapCenter/mockData';
import { dntList, dntReportNoAccess } from 'container/marketer/Reports/doNotTrackReport/mockData';
import { getRegisteredSupplierDiveristyAsyncAPIResponse, getSupplierDiversityCategoryResponse, getSupplierDiversityExpiringInApiResponse, getSupplierDiversityExpiringSupplierResponse, getSupplierDiversityRegisteredSupplierResponse, getSupplierDiversityStateResponse, getSupplierDiversitySummaryCountResponse, postRegisteredSupplierExpiringApiRequest, postRegisteredSupplierRequest, postSupplierDiversityExpiringInApiResponse, postSupplierDiversityRegisteredSupplierRequest } from 'services/supplierDiversity/mockData';

// array in local storage for registered users
const usersKey = 'react-18-redux-registration-login-example-users';
const portalAccessKey = 'portal-access-data';
const mapCenterUserKey = 'map-center-user-datas';
const supplierDiversityUserKey = "supply-diversity-user-datas";
const userProfileKey = "user-profile-details-data";
const supportDetailsKey = "support-details-data";
const adminUserProfileKey = "admin-user-profile-data";
const IndividualUserKey = JSON.parse(sessionStorage.getItem('userId')) || ''; // TODO: derive userId from auth slice
let users = JSON.parse(sessionStorage.getItem(usersKey)) || [];
let registerPortalData = portalData;
let userVerifyData = userRegistrationVerified;
let getFailedRes = false; // getFailedRes = true; //set false to test the failed response     

const fakeBackend = () => {
    let realFetch = window.fetch;
    window.fetch = function (url, opts) {
        return new Promise((resolve, reject) => {
            // wrap in timeout to simulate server api call
            setTimeout(handleRoute, 500);

            function handleRoute() {
                switch (true) {
                    case url.endsWith('/api/Account/refreshToken') && opts.method === 'POST':
                        return refreshToken();
                    case url.endsWith('/api/Account/Register') && opts.method === 'POST':
                        return register();                    
                    case url.match(/\/api\/Account\/\d+$/) && opts.method === 'PUT':
                        return updateUser();
                    case url.match(/\/api\/Account\/\d+$/) && opts.method === 'DELETE':
                        return deleteUser();
                    case url.match(/\/api\/Account\/\d+$/) && opts.method === 'POST':
                        return upload();
                    case url.endsWith('/api/UserPortalRoleMapping/GetUserPortalRoleMapping') && opts.method === 'GET':
                        return getAccessData();
                    case url.endsWith('/api/UserPortalRoleMapping') && opts.method === 'PUT':
                        return postAccessData();
                    case url.endsWith('/api/Master/GetPortalDetails') && opts.method === 'GET':
                        return getPortalData();
                    case url.match(/\/api\/Account\/VerifiedEmailByUser\/\d+$/) && opts.method === 'GET':
                        return getVerifiedUserData();
                    case url.match(/\/api\/Account\/GetRegisterMapCentreAsync\/\d+$/) && opts.method === 'GET':
                        return getMapCenterUser();
                    case url.match('api/Account/Register-MC') && opts.method === 'POST':
                        return updateMapCenterUser();
                    case url.match(/\/api\/Account\/GetRegisterSupplierDiversityAsync\/\d+$/) && opts.method === 'GET':
                        return getSupplierDiversityUser();
                    case url.match('/api/Account/Register-SD') && opts.method === 'POST':
                        return updateSupplierDiversityUser();
                    case url.match(/\/api\/Account\/getUserProfileDetails\/\d+$/) && opts.method === 'GET':
                        return getUserProfileDetails();
                    case url.match(/\/api\/Account\/getIndividualUserDetails\/\d+$/) && opts.method === 'GET':
                        return getById();
                    case url.match(/\/api\/Account\/GetUserProfileByPortalID\/\d+$/) && opts.method === 'GET':
                        return getUserProfile();
                    case url.match('api/Account/SaveUserProfile') && opts.method === 'PUT':
                        return updateUserProfileDetails();
                    case url.match(/\/api\/Account\/GetSupportByID\/\d+$/) && opts.method === 'GET':
                        return getSupportDetails();
                    case url.match(/api\/Master\/SaveSupportDetails/) && opts.method === 'PUT':
                        return updateSupportDetails();
                    case url.match(/\/api\/Announcement\/GetAnnouncementByID\?userID=\d+$/) && opts.method === 'GET':
                        return getAnnouncements();
                    case url.match(/\/api\/Announcement\/GetAnnouncementByAllRole\?userID=\d+$/) && opts.method === 'GET':
                        return getAnnouncements();
                    case url.match(/\/api\/FAQ\/GetAllFAQ\?userID=\d+$/) && opts.method === 'GET':
                        return getFAQs();
                    case url.match(/\/api\/FAQ\/GetFAQByAdminRole\?userID=\d+$/) && opts.method === 'GET':
                        return getFAQs();
                    case url.match('/api/Master/GetAllMarketers') && opts.method === 'GET':
                        return getMarketers();
                    case url.match(/\/api\/MarketerGroup\/GetMarketersGroupByMarketerID\/\d+$/) && opts.method === 'GET':
                        return getMarketerGroups();
                    case url.match('/api/energy-assistance/profile-information') && opts.method === 'POST':
                        return postProfileInfo();
                    case url.match('/api/energy-assistance/current-bill') && opts.method === 'POST':
                        return postCurrentBilling();
                    case url.match('/api/energy-assistance/energy-usage') && opts.method === 'POST':
                        return postEnergyUsage();
                    case url.match('/api/energy-assistance/reconnect-service/available-appointments') && opts.method === 'POST':
                        return getAvailableAppointment();
                    case url.match('/api/energy-assistance/reconnect-service') && opts.method === 'POST':
                        return postReconnectService();
                    case url.match('/api/energy-assistance/account-search') && opts.method === 'POST':
                        return getAccountLookup();
                     case url.match('/api/energy-assistance/advance-search') && opts.method === 'POST':
                        return getAdvanceSearch();
                    case url.match('/api/energy-assistance/grant-information') && opts.method === 'POST':
                        return postGrantInfo();
                    case url.match('/api/energy-assistance/report/account-balance') && opts.method === 'POST':
                        return getAccountBalance();
                    case url.match('/api/energy-assistance/billing-payment-history') && opts.method === 'POST':
                        return postBillingPaymentHistory();
                    case url.match('/api/energy-assistance/bill-details/download') && opts.method === 'POST':
                        return postBillHistoryPDF();
                    case url.match('/api/energy-assistance/current-bill/download') && opts.method === 'POST':
                        return postCurrentBillPDF();
                    case url.match('/api/energy-assistance/emergency-hold') && opts.method === 'POST':
                        return postEmergencyHold();
                    case url.match('/api/energy-assistance/emergency-hold/status') && opts.method === 'POST':
                        return postEmergencyHoldStatus();                    
                    case url.match('/api/map-center/request-type') && opts.method === 'GET':
                         return getMCReqtType();
                    case url.match('/api/map-center/map-request/type') && opts.method === 'GET':
                        return getRequestType();
                    case url.match('/api/map-center/map-request/county') && opts.method === 'GET':
                        return getCounty();
                    case url.match('/api/map-center/map-request/state') && opts.method === 'GET':
                        return getState();
                    case url.match('/api/map-center/map-request/create') && opts.method === 'POST':
                        return (getFailedRes) ? postMapRequestCreateFailedResponse: postMapRequestCreate();
                    case url.match('/api/map-center/map-request/filter') && opts.method === 'POST':
                        return getFilteredMapRequest();
                    case url.match('/api/Account/map-center/partially-approve') && opts.method === 'POST':
                        return postPartialApproveUser();
                    case url.match('/api/Account/map-center/partially-approved-registration') && opts.method === 'GET':
                        return getPartiallyApprovedDetails();
                    case url.match('/api/Account/map-center/partially-approved-registration') && opts.method === 'POST':
                        return updatePartiallyApproved()
                    case url.match(/\/api\/map-center\/map-request\/interaction-history(\/\d+)?$/) && opts.method === 'GET':
                        return getViewHistory();
                    case url.match('/api/energy-assistance/report/energy-usage') && opts.method === 'POST':
                        const failedResponse = false;
                        return handleMockResponse(failedResponse ? energyUsageResponse : energyUsageReport);
                    case url.match("/api/energy-assistance/agencies") && opts.method === "POST":
                      return getAgencyList();
                    case url.match("/api/energy-assistance/pledge-amount") && opts.method === "POST":
                      return postPledgeAmount();
                    case url.match("/api/marketer/do-not-transfer") && opts.method === "GET":
                      return getDNTReportData();                    
                    case url.match(/\/api\/map-center\/map-request\/\d+$/) && opts.method === 'GET':                                
                        return (getFailedRes) ? handleMockResponse(getMapRequestByIdFailedReponse) : getMapRequestById();
                    case url.match('/api/map-center/map-request') && opts.method === 'GET': 
                        return (getFailedRes) ? handleMockResponse(getMapRequestByIdFailedReponse) : getMapRequestApi();
                    case url.match('/api/energy-assistance/report/outstanding-grants') && opts.method === 'POST': 
                        return postOutstandingGrantReports();
                    case url.match('/api/supplier-diversity/registered-supplier') && opts.method === 'GET':
                        return (getFailedRes) ? handleMockResponse(failedResponse) : getSupplierDiversityDetailsApi();
                     case url.match('/api/supplier-diversity/supplier-summary-count') && opts.method === 'GET':
                        return (getFailedRes) ? handleMockResponse(failedResponse) : getSupplierDiversitySummaryCountApi();
                    case url.match('/api/supplier-diversity/state') && opts.method === 'GET':
                        return (getFailedRes) ? handleMockResponse(failedResponse) :  
                        getSupplierDiversityStateApi()
                    case url.match('/api/supplier-diversity/expiring-supplier') && opts.method === 'GET':
                        return (getFailedRes) ? handleMockResponse(failedResponse) : getSupplierDiversityExpiringSupplierApi();    
                    case url.match('/api/Account/GetBusinessCategory') && opts.method === 'GET':
                        return (getFailedRes) ? handleMockResponse(failedResponse) : getSupplierDiversityCategoryApi();  
                    case url.match('/api/supplier-diversity/regsitered-supplier') && opts.method === 'POST' : 
                        return (getFailedRes) ? handleMockResponse(failedResponse) :
                    postRegisteredSupplierFilterApi();
                    case url.match('/api/supplier-diversity/expiring-in') && opts.method === 'POST' : return (getFailedRes) ? handleMockResponse(failedResponse) :postSupplierDiversityExpiringInApi();
                    case url.match(/\/api\/Account\/GetRegisterSupplierDiversityAsync\/\/\d+$/) && opts.method === 'GET': return (getFailedRes) ? handleMockResponse(failedResponse) : getSupplierDiveristyAsyncApi();
                    case url.match('/api/supplier-diversity/expiring-supplier') && opts.method === 'POST' : 
                        return (getFailedRes) ? handleMockResponse(failedResponse) :
                    postExpiringSupplierApi();
                    case url.match('/api/Account/GetBusinessCategory') && opts.method === 'GET': 
                        return getBusinessCategory();
                    case url.match('/api/Account/GetClassification') && opts.method === 'GET': 
                        return getClassification();
                    case url.match('/api/Account/GetDocumentType') && opts.method === 'GET': 
                        return getDocumentType();
                    case url.match('/api/Account/supplier-diversity/state') && opts.method === 'GET': 
                        return getSDState();
                    case url.match('/api/supplier-diversity/register-supplier/report') && opts.method === 'POST' : 
                        return (getFailedRes) ? handleMockResponse(failedResponse) :
                    registerSupplierDownloadApi();
                    default:
                        // pass through any requests not handled above
                        return realFetch(url, opts)
                            .then(response => resolve(response))
                            .catch(error => reject(error));
                }
            }

            //handling mockResponse 
            function handleMockResponse(data) {
                try {
                    return ok(data);
                } catch (err) {
                    return error('Failed to get details');
                }
            }

            // route functions            

            function refreshToken() {
                if (!isAuthenticated()) return unauthorized();
                // let auth = JSON.parse(sessionStorage.getItem('auth')) || [];
                //const user = users.find(x => x.id === auth?.id);               

                let currentDateTime = new Date();
                let expiryTime = currentDateTime.setMinutes(currentDateTime.getMinutes() + 7);

                return ok({
                    token: 'fake-jwt-refreshtoken',
                    tokenExpiry: expiryTime/*'2024-09-25 21:05:24.789150'                 */
                });
            }

            function register() {
                const user = body();

                if (users.find(x => x.EmailAddress === user.EmailAddress)) {
                    return error('email "' + user.EmailAddress + '" is already taken')
                }

                user.id = users.length ? Math.max(...users.map(x => x.id)) + 1 : 1;
                user.createdDate = new Date();
                user.status = 1;
                users.push(user);
                sessionStorage.setItem(usersKey, JSON.stringify(users));

                return ok();
            }            

            function updateUser() {
                if (!isAuthenticated()) return unauthorized();

                const { data, portalName } = body();
                let params = data;
                let user = users.find(x => x.id === idFromUrl());

                // only update password if entered
                if (!params.password) {
                    delete params.password;
                }

                // if email changed check if taken
                if (params.emailAddress !== user.emailAddress && users.find(x => x.emailAddress === params.emailAddress)) {
                    return error('email "' + params.emailAddress + '" is already taken')
                }

                // update and save user

                let userAccess = {
                    ...params,
                    UserAccess: params.UserAccess.map(portal =>
                        portal.PortalName === portalName
                            ? { ...portal, IsProfileCompleted: 1 }
                            : portal
                    )
                };

                Object.assign(user, userAccess);

                sessionStorage.setItem(usersKey, JSON.stringify(users));
                return ok();
            }

            function deleteUser() {
                if (!isAuthenticated()) return unauthorized();

                users = users.filter(x => x.id !== idFromUrl());
                sessionStorage.setItem(usersKey, JSON.stringify(users));
                return ok();
            }

            function upload() {

                return ok({
                    viewuri: 'https://freeimage.host/i/dyXxVKN',

                });
            }

            function getAccessData() {
                let accessData = JSON.parse(sessionStorage.getItem(portalAccessKey)) || portalAccessData;;
                return ok(accessData);
            }

            function postAccessData() {
                // Retrieve the access data from the body function
                const accessData = body();
                let portalAccess = JSON.parse(sessionStorage.getItem(portalAccessKey)) || portalAccessData;
                let newAccesData = { ...portalAccess };

                // Create a new array for the updated portal access data
                const updatedPortalAccess = portalAccess?.Data.map(portal => {
                    // Create a shallow copy of the portal object
                    const newPortal = { ...portal };
                    newPortal.PortalRoleAccess = portal.PortalRoleAccess.map(roleAccess => {
                        // Create a shallow copy of the roleAccess object
                        const newRoleAccess = { ...roleAccess };
                        newRoleAccess.FeatureAccess = roleAccess.FeatureAccess.map(permission => {
                            // Create a shallow copy of the permission object
                            const newPermission = { ...permission };
                            // Find the corresponding changed data
                            const changedData = accessData.find(x => x.RoleAccessMappingID === permission.RoleAccessMappingID);
                            // Update the permission if there is a corresponding change
                            if (changedData && permission.RoleAccessMappingID === changedData.RoleAccessMappingID) {
                                newPermission.IsActive = changedData.IsActive;
                            }
                            return newPermission;
                        });
                        return newRoleAccess;
                    });
                    return newPortal;
                });

                newAccesData.Data = updatedPortalAccess;
                // Store the updated portal access data in sessionStorage
                sessionStorage.setItem(portalAccessKey, JSON.stringify(newAccesData));

                // Return a successful response
                return ok();
            }

            function getPortalData() {
                return ok(registerPortalData);
            }

            function getVerifiedUserData() {

                return ok(userVerifyData);
            }

            function getMapCenterUser() {
                try {
                    let mapCenterUser = JSON.parse(sessionStorage.getItem(mapCenterUserKey)) || getMapCenterData;;
                    return ok(mapCenterUser);
                }
                catch (error) {
                    return error('Failed to get map center user');
                }
            }

            function getSupplierDiversityUser() {
                try {
                    let supplierDiversityUser = JSON.parse(sessionStorage.getItem(supplierDiversityUserKey)) || getSupplierDiversityData;
                    return ok(supplierDiversityUser);
                }
                catch (error) {
                    return error('Failed to get Supplier Diversity User');
                }
            }

            function getUserProfileDetails() {
                try {
                    let userProfileDetails = JSON.parse(sessionStorage.getItem(userProfileKey)) || getMyProfileData;
                    return ok(userProfileDetails);
                }
                catch (error) {
                    return error('Failed to get  user');
                }
            }

            function getById() {
                try {
                    let userProfileDetails = JSON.parse(sessionStorage.getItem(IndividualUserKey)) || IndividualUserData;
                    return ok(userProfileDetails);
                }
                catch (error) {
                    return error('Failed to get  user');
                }

            }
            function getUserProfile() {
                try {
                    let userProfile = JSON.parse(sessionStorage.getItem(adminUserProfileKey)) || getAIUserProfileData;
                    return ok(userProfile);
                }
                catch (error) {
                    return error('Failed to get  user Details');
                }
            }
            function getSupportDetails() {
                try {
                    let supportDetail = getSupportData;
                    return ok(supportDetail);
                }
                catch (error) {
                    return error('Failed to get details');
                }
            }

            function getAnnouncements() {
                try {
                    let announcement = announcementData;
                    return ok(announcement);
                }
                catch (error) {
                    return error('Failed to get details');
                }
            }

            function getFAQs() {
                try {
                    let faq = faqData;
                    return ok(faq);
                }
                catch (error) {
                    return error('Failed to get details');
                }
            }

            function getMarketers() {
                try {
                    let marketerts = marketerGetData;
                    return ok(marketerts);
                }
                catch (error) {
                    return error('Failed to get details');
                }
            }

            function getMarketerGroups() {
                try {
                    let marketertGroups = marketerGroupGetData;
                    return ok(marketertGroups);
                }
                catch (error) {
                    return error('Failed to get details');
                }
            }

            function postProfileInfo() {
                try {
                    return ok(profileInfo);
                }
                catch (error) {
                    return error('Failed to get details');
                }
            }

            function postCurrentBilling() {
                try {
                    return ok(currentBilling);
                }
                catch (error) {
                    return error('Failed to get details');
                }
            }

            function postEnergyUsage() {
                try {
                    return ok(energyUsage);
                }
                catch (error) {
                    return error('Failed to get details');
                }
            }

            function postReconnectService() {
                try {
                    return ok(reconnectServiceResponse);
                }
                catch (error) {
                    return error('Failed to get details');
                }
            }

            function getAccountLookup() {
                try {
                    return ok(accountLookupResponse);
                }
                catch (error) {
                    return error('Failed to get details');
                }
            }

            function getAdvanceSearch() {
                try {
                    return ok(advanceSearchResponse);
                }
                catch (error) {
                    return error('Failed to get details');
                }
            }

             function postGrantInfo() {
                try {
                    return ok(grantInfo);
                }
                catch (error) {
                    return error('Failed to get details');
                }
            }

            function getAccountBalance() {
                try {
                    return ok(accountBalanceResponse);
                }
                catch (error) {
                    return error('Failed to get details');
                }
            }

            function postBillingPaymentHistory() {
                try {
                    return ok(billingAndPaymentHistory);
                }
                catch (error) {
                    return error('Failed to get details');
                }
            }

            function postBillHistoryPDF() {
                try {
                    return ok(billHistoryPDF);
                }
                catch (error) {
                    return error('Failed to get details');
                }
            }

            function postCurrentBillPDF() {
                try {
                    return ok(currentBillingPDF);
                }
                catch (error) {
                    return error('Failed to get details');
                }
            }

            function postEmergencyHold() {
                try {
                    return ok(emergencyHold);
                }
                catch (error) {
                    return error('Failed to get details');
                }
            }

            function postEmergencyHoldStatus() {
                try {
                    return ok(emergencyHoldStatus);
                }
                catch (error) {
                    return error('Failed to get details');
                }
            }

            function getAvailableAppointment() {
                try {
                    return ok(getAvailableAppointmentResponse);
                }
                catch (error) {
                    return error('Failed to get details');
                }
            }

            function getMCReqtType() {
                try {
                    return ok(getMCReqTypeResponse);
                }
                catch (error) {
                    return error('Failed to get details');
                }
            }
            
            function getRequestType() {
                try {
                    return ok(getRequestTypeResponse);
                }
                catch (error) {
                    return error('Failed to get details');
                }
            }

            function getMapRequestApi() {
                try {
                    return ok(getMapRequest);
                }
                catch (error) {
                    return error('Failed to get details');
                 }
            }

            
            function getMapRequestById() {
                try {
                    return ok(getMapRequestByIdRequest);
                }
                catch (error) {
                    return error('Failed to get details');
                 }
            }            


            function getCounty() {
                try {
                    return ok(getCountyResponse);
                }
                catch (error) {
                    return error('Failed to get details');
                }
            }

            function getState() {
                try {
                    return ok(getStateResponse);
                }
                catch (error) {
                    return error('Failed to get details');
                }
            }

            function postMapRequestCreate() {
                try {
                    return ok(postMapRequestCreateResponse);
                }
                catch (error) {
                    return error('Failed to get details');
                }
            }

            function getFilteredMapRequest() {
                try {
                    return ok(getFilteredMapRequestResponse);
                }
                catch (error) {
                    return error('Failed to get details');
                }
            }

            function postPartialApproveUser() {
                try {
                    return ok(postPartiallyApproveUserResponse);
                }
                catch (error) {
                    return error('Failed to get details');
                }
            }

            function getPartiallyApprovedDetails() {
                try {
                    return ok(getPartiallyApprovedDetailsResponse);
                }
                catch (error) {
                    return error('Failed to get details');
                }
            }

            function updatePartiallyApproved() {
                try {
                    return ok(updatePartiallyApprovedResponse);
                }
                catch (error) {
                    return error('Failed to get details');
                }
            }

            function getViewHistory() {
                try {
                    return ok(getViewHistoryResponse);
                }
                catch (error) {
                    return error('Failed to get details');
                }
            }

            function getAgencyList() {
              try {
                return ok(agencyList);
              } catch (error) {
                return error("Failed to get details");
              }
            }

            function postPledgeAmount() {
              try {
                return ok(pledgeAmtFailed);
              } catch (error) {
                return error(pledgeAmtFailed);
              }
            }

            function getDNTReportData() {
              try {
                return ok(dntList);
              } catch (error) {
                return error(dntReportNoAccess);
              }
            }

            function updateMapCenterUser() {
                try {
                    const mapCenterData = body();

                    let mapCenterUserData = JSON.parse(sessionStorage.getItem(mapCenterUserKey)) || getMapCenterData;

                    // Create a deep copy of the object to avoid modifying read-only properties
                    let newData = JSON.parse(JSON.stringify(mapCenterData));

                    newData.Data.DocumentData = [...mapCenterUserData.Data.DocumentData];

                    // Save the updated data back to sessionStorage
                    sessionStorage.setItem(mapCenterUserKey, JSON.stringify(newData));

                    // Return a successful response
                    return ok();
                } catch (err) {

                    return error('Failed to update map center user');
                }
            }

            function updateSupplierDiversityUser() {
                try {
                    const supplierDiversityData = body();

                    let supplierDiversityUserData = JSON.parse(sessionStorage.getItem(supplierDiversityUserKey)) || getSupplierDiversityData;

                    // Create a deep copy of the object to avoid modifying read-only properties
                    let newData = JSON.parse(JSON.stringify(supplierDiversityData));

                    newData.Data.DocumentData = [...supplierDiversityUserData.Data.DocumentData];
                    newData.Data.State1 = [...supplierDiversityUserData.Data.State1];
                    newData.Data.BusinessCategory = [...supplierDiversityUserData.Data.BusinessCategory];
                    newData.Data.Classification = [...supplierDiversityUserData.Data.Classification];
                    newData.Data.Agency = [...supplierDiversityUserData.Data.Agency];
                    // Save the updated data back to sessionStorage
                    sessionStorage.setItem(supplierDiversityUserKey, JSON.stringify(newData));

                    // Return a successful response
                    return ok();
                } catch (err) {

                    return error('Failed to update Supplier Diversity user');
                }
            }

            function getBusinessCategory () {
                try {
                    return ok(businessCategory);
                } catch (error) {
                    return error('Failed to fetch business category');
                }
            }

            function getClassification () {
                try {
                    return ok(classification);
                } catch (error) {
                    return error('Failed to fetch business category');
                }
            }

            function getDocumentType () {
                try {
                    return ok(documentType);
                } catch (error) {
                    return error('Failed to fetch business category');
                }
            }

            function getSDState () {
                try {
                    return ok(state);
                } catch (error) {
                    return error('Failed to fetch business category');
                }
            }

            function updateUserProfileDetails() {
                try {
                    const userProfileData = body();

                    let userProfileJsonData = JSON.parse(sessionStorage.getItem(userProfileKey)) || getMyProfileData;

                    // Create a deep copy of the object to avoid modifying read-only properties
                    let newData = JSON.parse(JSON.stringify(userProfileData));

                    newData.Data.State = [...userProfileJsonData.Data.State];
                    // Save the updated data back to sessionStorage
                    sessionStorage.setItem(userProfileKey, JSON.stringify(newData));

                    // Return a successful response
                    return ok();
                } catch (err) {

                    return error('Failed to update user');
                }
            }

            function updateSupportDetails() {
                try {
                    const supportData = body();
                    // Create a deep copy of the object to avoid modifying read-only properties
                    let newData = JSON.parse(JSON.stringify(supportData));

                    // Save the updated data back to sessionStorage
                    sessionStorage.setItem(supportDetailsKey, JSON.stringify(newData));

                    // Return a successful response
                    return ok();
                } catch (err) {

                    return error('Failed to update details');
                }
            }

            function postOutstandingGrantReports() {
                try {
                    return ok(outstandingGrantData);
                } catch (error) {
                    return error('Failed to fetch details.');
                }
            }

            //supplier diversity
            function getSupplierDiversityDetailsApi(){
                try {
                return ok(getSupplierDiversityRegisteredSupplierResponse);
              } catch (error) {
                return error("Failed to get details");
              }
            }
            
            function getSupplierDiversitySummaryCountApi(){
                try {
                return ok(getSupplierDiversitySummaryCountResponse);
              } catch (error) {
                return error("Failed to get details");
              }
            }

            function getSupplierDiversityStateApi(){
                try {
                return ok(getSupplierDiversityStateResponse);
              } catch (error) {
                return error("Failed to get details");
              }
            }

            function getSupplierDiversityCategoryApi(){
                try {
                return ok(getSupplierDiversityCategoryResponse);
              } catch (error) {
                return error("Failed to get details");
              }
            }
        
            function getSupplierDiversityExpiringSupplierApi(){
                try {
                return ok(getSupplierDiversityExpiringSupplierResponse);
              } catch (error) {
                return error("Failed to get details");
              }
            }

            function postRegisteredSupplierFilterApi(){
                try {
                    return ok(postRegisteredSupplierRequest);
                } catch (error) {
                    return error("Failed to get details");
                }
            }

            function postSupplierDiversityExpiringInApi(){
            try {
                    return ok(postSupplierDiversityExpiringInApiResponse);
                } catch (error) {
                    return error("Failed to get details");
                }
            } 
            
            function getSupplierDiveristyAsyncApi(){
            try {
                    return ok(getRegisteredSupplierDiveristyAsyncAPIResponse);
                } catch (error) {
                    return error("Failed to get details");
                }
            }
            
            function postExpiringSupplierApi(){
                try {
                    return ok(postRegisteredSupplierExpiringApiRequest);
                } catch (error) {
                    return error("Failed to get details");
                }
            }
            function registerSupplierDownloadApi(){
                try {
                    return ok(postRegisteredSupplierDownloadReport);
                } catch (error) {
                    return error("Failed to get details");
                }
            }
            // helper functions

            function ok(body) {
                resolve({ ok: true, ...headers(), json: () => Promise.resolve(body) })
            }

            function unauthorized() {
                resolve({ status: 401, ...headers(), json: () => Promise.resolve({ message: 'Unauthorized' }) })
            }

            function error(message) {
                resolve({ status: 400, ...headers(), json: () => Promise.resolve({ message }) })
            }

            function isAuthenticated() {
                return opts.headers['Authorization'] === 'Bearer fake-jwt-token' || 'Bearer fake-jwt-refreshtoken';
            }

            function body() {
                return opts.body && JSON.parse(opts.body);
            }

            function idFromUrl() {
                const urlParts = url.split('/');
                return parseInt(urlParts[urlParts.length - 1]);
            }

            function headers() {
                return {
                    headers: {
                        get(key) {
                            return ['application/json'];
                        }
                    }
                }
            }
            
        });
    }
}

export default fakeBackend; 